export default __webpack_public_path__ + "static/hero-video-54080dd881974bd8c35362cd8f440fc6.mp4";